var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeviceWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0635 15.9655C12.8211 16.0384 12.4543 16.1487 12 16.1487C11.1812 16.1487 10.4245 15.9253 9.75208 15.4847C9.07606 15.0414 8.56291 14.4647 8.21709 13.7524L4.38685 7.03906L4.12772 7.50244C3.38124 8.83797 3.00244 10.3504 3.00244 11.9979C3.00244 14.2367 3.74174 16.218 5.19994 17.8861C6.65692 19.5524 8.49541 20.5635 10.6641 20.8901L10.8662 20.9207L13.8663 15.7297L13.0635 15.9655Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94181 10.8722C8.16796 9.98804 8.67482 9.23556 9.4486 8.63572C10.1759 8.07247 11.0106 7.79866 12 7.79866H19.9981L19.733 7.34697C18.9778 6.05882 17.9143 5.0283 16.4822 4.19574C15.1167 3.4022 13.6084 3 12 3C10.6003 3 9.27555 3.30172 8.06269 3.89706C6.76975 4.53109 5.67145 5.42572 4.88717 6.48532L4.76721 6.64758L7.76579 11.5611L7.94181 10.8722Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3146 8.6071L20.2333 8.43555H14.2659L14.7778 8.94752C15.6635 9.83346 16.1512 10.9162 16.1512 11.9971C16.1512 12.8608 15.9055 13.6616 15.4098 14.3952L11.5786 20.9996L12.1053 20.9945C14.5544 20.9711 16.6712 20.0723 18.3975 18.3232C20.1226 16.5741 20.9975 14.4456 20.9975 11.997C20.9975 11.1075 20.879 9.79716 20.3146 8.6071Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40112 11.9974C8.40112 13.9484 10.0492 15.5964 12.0001 15.5964C13.9511 15.5964 15.5991 13.9484 15.5991 11.9974C15.5991 10.0465 13.9511 8.39844 12.0001 8.39844C10.0492 8.39844 8.40112 10.0465 8.40112 11.9974Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceWeb);
export default __webpack_public_path__ + "static/media/deviceWeb.1d7d686702fd77d59924da781194e3b9.svg";
export { ForwardRef as ReactComponent };